import React, { Component } from 'react';
import { Link } from 'react-router-dom';
class NotFoundComponent extends Component{
    render(){
        return  (<div>
        <div id="notfound">
          <div class="notfound">
            <div class="notfound-404">
              <h1>Oops!</h1>
            </div>
            <h2>404 - Page not found</h2>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
            <button
              class="btn btn-outline-success my-2 my-sm-0"
            ><Link to="/">Go to Home</Link></button>
          </div>
        </div>
      </div>
        )
    }
}
export default NotFoundComponent;